/**
 * @Description CFO 经营分析 FPA 接口
 */
import request from '@/utils/request'

export function unwrapFpaResponse(res) {
  if (res == null) return res
  if (Array.isArray(res)) return res
  const payload = res.data
  const hasBizPayload = payload != null && (
    Array.isArray(payload) ||
    payload.impact ||
    payload.parameters ||
    payload.presets ||
    payload.rows ||
    payload.meta ||
    payload.sections ||
    payload.summary ||
    payload.available_months
  )
  if (hasBizPayload && (res.code === 200 || res.code === 0 || res.code === '200' || res.code === undefined)) {
    return payload
  }
  if (res.impact || res.parameters || res.rows || res.meta || res.sections || res.summary || res.account_code || res.period_key || res.attr_name) {
    return res
  }
  return res
}

/** E2E损益表 */
export function fetchPlStatement(periodKey = 202605) {
  return request({
    url: '/cfo-api/api/fpa/pl-statement',
    method: 'GET',
    params: { period_key: periodKey }
  })
}

/** 毛利率月度趋势 */
export function fetchGmTrend() {
  return request({
    url: '/cfo-api/api/fpa/gm-trend',
    method: 'GET'
  })
}

/** 收入差异归因 */
export function fetchRevenueAttribution(periodKey = 202605) {
  return request({
    url: '/cfo-api/api/fpa/revenue-attribution',
    method: 'GET',
    params: { period_key: periodKey }
  })
}

/** 7+3滚动预测 */
export function fetchRollingForecast() {
  return request({
    url: '/cfo-api/api/fpa/rolling-forecast',
    method: 'GET'
  })
}

/** What-if 场景模拟 */
export function fetchWhatIf() {
  return request({
    url: '/cfo-api/api/fpa/what-if',
    method: 'GET'
  })
}
